import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './recycle.png'


const _withScopeId = n => (_pushScopeId("data-v-0a135569"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-5",
  class: "page-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "d-none d-md-block img-recycle"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 캠페인 일정 ", -1))
const _hoisted_4 = { class: "rounds" }
const _hoisted_5 = { class: "round-title" }
const _hoisted_6 = { class: "round-content-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 지원 기간 ", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "round-content-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 당첨자 선정 ", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "round-content-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" 제로 웨이스트"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 박스 수령 ")
], -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "round-content-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 수거 신청 기간 ", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"box-desc\" data-v-0a135569><h4 class=\"desc-title\" data-v-0a135569> 꼭 확인해주세요! </h4><div class=\"desc-content d-block d-md-none\" data-v-0a135569> • 챌린지 유형은 한 번 신청하면 변경할 수 없어요. <br data-v-0a135569> 유형 정보와 리워드 혜택을 확인 후 신중하게 선택해주세요. <br data-v-0a135569> • 제로 웨이스트 박스는 당첨자 선정일 이후 일괄 발송돼요. <br data-v-0a135569> (한진택배를 통해 2~3일 후 배송될 예정이며 지역에 따라<br data-v-0a135569>실제 수령일은 달라질 수 있어요.) <br data-v-0a135569> • 수거 품목은 &#39;투명 음료 페트병&#39;이에요. <br data-v-0a135569> 페이지 하단의 수거 가이드를 꼭 확인해주세요. </div><div class=\"desc-content d-none d-md-block\" data-v-0a135569> • 챌린지 유형은 한 번 신청하면 변경할 수 없어요. 유형 정보와 리워드 혜택을 확인 후 신중하게 선택해주세요. <br data-v-0a135569> • 제로 웨이스트 박스는 당첨자 선정일 이후 일괄 발송돼요. <br data-v-0a135569> (한진택배를 통해 2~3일 후 배송될 예정이며 지역에 따라 실제 수령일은 달라질 수 있어요.) <br data-v-0a135569> • 수거 품목은 &#39;투명 음료 페트병&#39;이에요. 페이지 하단의 수거 가이드를 꼭 확인해주세요. </div></div>", 1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 캠페인 지원하기 ")

import { IProgram } from '@/types/program';
import { computed } from 'vue';
import dayjs from 'dayjs';
import Participate from '../participate/index.vue';

interface Props {
  program: IProgram
}

export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
  program: IProgram
}



const rounds = computed(() => {
  const format = 'M월 D일';
  const dateFormat = (item: string) => dayjs(item).format(format);
  const $now = dayjs();
  return props.program.program_rounds?.map(item => {
    return {
      participateOn: [item.participate_started_at, item.participate_ended_at].map(dateFormat).join(' ~ '),
      announcedOn: dayjs(item.participate_ended_at).add(2, 'day').format(format),
      deliverOn: dayjs(item.participate_ended_at).add(3, 'day').format(format),
      collectOn: `${[item.collection_started_at, item.collection_ended_at].map(dateFormat).join(' ~ ')}(${Math.ceil(dayjs(item.collection_ended_at).diff(dayjs(item.collection_started_at), 'days', true))}일)`,
      isExpired: dayjs(item.collection_ended_at).isBefore($now),
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rounds), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "round"
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1) + "회차 ", 1),
          _createElementVNode("div", {
            class: _normalizeClass(["round-content", { 'expired': item.isExpired }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.participateOn), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.announcedOn), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.deliverOn) + "부터 순차적 발송 ", 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.collectOn), 1)
            ])
          ], 2)
        ]))
      }), 128))
    ]),
    _hoisted_18,
    _createVNode(Participate, {
      program: __props.program,
      class: "btn-submit-container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_button, { class: "btn-submit" }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["program"])
  ]))
}
}

})